<template>
  <div>
    <Search
      @handleSearch="handleSearch"
      @getHeight="getHeight"
      @add="addVisible = true"
      @saveSet="saveSet"
      :isquery="true"
      :advancedQuery="true"
      :tableConfig="tableConfig"
      :tableName="tableName"
      :showSort="false"
      :showDel="false"
      searchName="getUserList"
    >
      <template v-slot:left>
        <el-col :lg="24" :md="24" :sm="24" :xs="24">
          <el-form-item label="关键字">
            <el-input
              v-model="searchForm.keyWord"
              placeholder="请输入关键字"
            ></el-input>
          </el-form-item>
        </el-col>
      </template>
      <template v-slot:advancedQuery>
        <el-col :lg="5" :md="6" :sm="12" :xs="24">
          <el-form-item label="角色">
            <el-select v-model="searchForm.auth" clearable placeholder="不限">
              <el-option
                v-for="item in roleList"
                :label="item.roleName"
                :value="item.id"
                :key="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </template>
    </Search>
    <div class="page">
      <MyTable
        @selectChange="selectChange"
        @inputChange="inputChange"
        @sortChange="sortChange"
        :tableData="tableData"
        :tableConfig="tableConfig"
        :height="tableHeight"
        :indexFlag="true"
      >
        <template v-slot:index="slotData">
          {{
            ($refs.pagination.currentPage - 1) * $refs.pagination.pageSize +
            slotData.scope.$index +
            1
          }}
        </template>
        <template v-slot:roleId="slotData">
          {{ getRoleName(slotData.scope.row.roleId) }}
        </template>
        <template v-slot:operation="slotData">
          <el-button
            @click="editUserInfo(slotData.scope.row)"
            size="small"
            icon="el-icon-edit"
            v-if="verifyPermission('Update')"
            >编辑</el-button
          >
          <el-button
            @click="deleteUser(slotData.scope.row.id)"
            type="danger"
            plain
            size="small"
            icon="el-icon-delete"
            v-show="slotData.scope.row.account != account"
            v-if="verifyPermission('Delete')"
            >删除</el-button
          >
          <el-button
            @click="updateUserPassWord(slotData.scope.row.id)"
            type="primary"
            plain
            size="small"
            icon="el-icon-refresh-right"
            v-if="verifyPermission('Update')"
            >重置密码</el-button
          >
        </template>
      </MyTable>

      <Pagination
        class="PagPosition"
        :total="total"
        @getNewData="getUserList"
        ref="pagination"
      />
      <el-dialog
        title="重置密码"
        :show-close="false"
        :visible.sync="resetDialogVisible"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        width="350px"
      >
        <el-form
          :model="form"
          :rules="rules"
          size="small"
          ref="form"
          label-width="70px"
          label-position="left"
          v-enterToNext="true"
        >
          <el-form-item label="新密码" prop="password">
            <el-input
              v-model="form.password"
              type="password"
              show-password
              placeholder="输入新密码"
            ></el-input>
          </el-form-item>
          <el-form-item style="margin-bottom: 0; text-align: right">
            <el-button @click="resetDialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="changePassword('form')"
              >确 定</el-button
            >
          </el-form-item>
        </el-form>
      </el-dialog>
      <el-dialog
        :title="setDialogTitle"
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        width="700px"
        class="colleague-dialog"
        @close="resetForm"
      >
        <el-form
          ref="form"
          :model="form"
          :inline="true"
          :rules="rules"
          label-width="96px"
          size="mini"
        >
          <el-form-item label="账号" prop="account">
            <el-input
              v-model="form.account"
              :disabled="isEdit"
              maxlength="50"
              :class="[isEdit ? '' : 'account_input']"
            >
              <template slot="prepend" v-if="isEdit == false">{{
                CompanyDetail.autoIntId + 1000 + "_"
              }}</template>
            </el-input>
          </el-form-item>
          <el-form-item label="姓名" prop="cname">
            <el-input
              v-model="form.cname"
              maxlength="30"
              auto-complete="new-password"
            ></el-input>
          </el-form-item>
          <el-form-item label="密码" prop="password" v-if="!isEdit">
            <el-input
              v-model="form.password"
              show-password
              maxlength="30"
              auto-complete="new-password"
            ></el-input>
          </el-form-item>
          <el-form-item label="确认密码" prop="password2" v-if="!isEdit">
            <el-input
              v-model="form.password2"
              show-password
              maxlength="30"
            ></el-input>
          </el-form-item>
          <el-form-item label="性别" prop="sex">
            <el-select v-model="form.sex">
              <el-option label="男" value="男"></el-option>
              <el-option label="女" value="女"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="手机号码" prop="tel">
            <el-input
              v-model="form.tel"
              :disabled="isEdit"
              maxlength="11"
            ></el-input>
          </el-form-item>
          <!-- <el-form-item label="微信号">
          <el-input v-model="form.wechat" maxlength="50"></el-input>
        </el-form-item>
        <el-form-item label="QQ号">
          <el-input v-model="form.qq" maxlength="20"></el-input>
        </el-form-item> -->
          <el-form-item label="备注">
            <el-input v-model="form.remark" maxlength="200"></el-input>
          </el-form-item>
          <el-form-item label="角色" prop="roleId">
            <el-select v-model="form.roleId">
              <el-option
                v-for="item in roleList"
                :label="item.roleName"
                :value="item.id"
                :key="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="是否管理员">
          <el-switch v-model="form.isManage"></el-switch>
        </el-form-item> -->
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button
            @click="
              () => {
                resetForm();
                dialogVisible = false;
                addVisible = false;
              }
            "
            >取 消</el-button
          >
          <el-button
            size="small "
            type="primary"
            :loading="submitLoading"
            @click="onSubmit('form')"
            >确 定</el-button
          >
        </span>
      </el-dialog>
      <el-dialog
        title="新增"
        :visible.sync="addVisible"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        width="440px"
        center
      >
        <div style="display: flex; justify-content: center">
          <el-button
            size="mini"
            type="success"
            @click="
              openDialog();
              addVisible = false;
            "
            >二维码新增</el-button
          >
          <el-button
            size="mini"
            type="primary"
            @click="
              addVisible = false;
              dialogVisible = true;
              isEdit = false;
            "
            style="margin-left: 15px"
            >PC端新增</el-button
          >
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button
            size="small "
            :loading="submitLoading"
            @click="addVisible = false"
            >关 闭</el-button
          >
        </span>
      </el-dialog>
      <el-dialog
        title="二维码新增管理员"
        :visible.sync="QRVisible"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        width="400px"
        center
      >
        <div style="display: flex; justify-content: center">
          <img :src="imgPath" alt="" v-if="$shareType == 2" />
          <div id="qrcode" ref="qrcode" v-if="$shareType == 1"></div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { verifyPermissionMinix, GetUnlimitedQRCodeMinix } from "@/utils/mixin";
import Search from "@/components/Search";
import MyTable from "@/components/Table";

export default {
  mixins: [verifyPermissionMinix, GetUnlimitedQRCodeMinix],
  components: { Search, MyTable },
  data() {
    return {
      tableName: "myColleagueTable",
      tableConfig: [
        {
          field: "account",
          label: "账号",
          // style: 1,
          flag: true,
          sortable: true,
        },
        {
          field: "cname",
          label: "姓名",
          width: 160,
          // style: 1,
          flag: true,
          sortable: true,
        },
        {
          field: "sex",
          label: "性别",
          width: "80",
          align: "center",
          flag: true,
          sortable: true,
        },
        {
          field: "tel",
          label: "手机号码",
          align: "center",
          width: 160,
          // style: 1,
          flag: true,
          sortable: true,
        },
        {
          field: "remark",
          label: "备注",
          minWidth: 40,
          align: "center",
          // style: 1,
          flag: true,
          sortable: true,
        },
        {
          field: "roleId",
          label: "角色",
          minWidth: 30,
          align: "center",
          slotName: "roleId",
          width: 100,
          // style: 2,
          sortable: true,
          flag: true,
        },

        {
          label: "操作",
          slotName: "operation",
          width: 300,
          align: "left",
          flag: true,
        },
      ],
      submitLoading: false,
      dialogVisible: false,
      resetDialogVisible: false,
      loading: false,
      imgPath: "",
      currentPage: 1,
      addVisible: false,
      QRVisible: false,
      tableData: [],
      searchForm: {
        checked: [],
      },
      form: {},
      rules: {
        newPwd: [
          { required: true, message: "请输入新密码", trigger: "blur" },
          { required: true, message: "密码最少6位字符", min: 6 },
        ],
        account: [{ required: true, message: "请输入账号", trigger: "blur" }],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              const check =
                /^(?=.{8})(?=.*?[a-z])(?=.*?[A-Z])(?=.*?\d)(?=.*?[*?!&￥$%^#,./@";:><\[\]}{\-=+_\\|》《。，、？’‘“”~ `]).*$/;
              if (check.test(value)) {
                callback();
              } else {
                callback(new Error("至少8位，数字+大小写字母+特殊字符"));
              }
            },
            trigger: ["blur", "change"],
          },
        ],
        password2: [
          { required: true, message: "请再次输入密码", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              if (this.form.password !== value) {
                callback(new Error("两次输入密码不一致"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        cname: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        tel: [{ required: true, message: "请输入电话号码", trigger: "blur" }],
        currentJob: [
          { required: true, message: "请输入目前职位", trigger: "blur" },
        ],
        roleId: [{ required: true, message: "请选择角色", trigger: "blur" }],
      },
      roleList: [],
      total: 0,
      isEdit: false,
      account: "",
      teamList: [],
      industryData: [],
      tableHeight: "",
      id: "",
      QRVisible: false,
      userAutoIntId: "",
      CompanyDetail: {},
      userInfo: {},
    };
  },
  mounted() {
    this.getRoleList();
    this.getUserList();
    this.getTeamList();
    this.account = JSON.parse(window.localStorage.getItem("userInfo")).account;
    this.userInfo = JSON.parse(window.localStorage.getItem("userInfo"));
    this.CompanyDetail = JSON.parse(
      window.localStorage.getItem("CompanyDetail")
    );
    this.userAutoIntId = this.userInfo.autoIntId;
    if (localStorage.getItem(this.tableName)) {
      this.tableConfig = JSON.parse(localStorage.getItem(this.tableName));
      this.sortType = this.tableConfig.pop();
      this.tableConfig.forEach((element) => {
        if (element.sortable) {
          element.sortable = this.sortType;
        }
      });
    }
  },
  computed: {
    setDialogTitle() {
      return this.isEdit ? "修改管理员信息" : "新增管理员";
    },
  },
  created() {},
  methods: {
    // 打开并生成二维码
    openDialog() {
      if (this.$shareType == 1) {
        this.QRVisible = true;
      }
      this.$nextTick(() => {
        this.qrcode();
      });
    },
    qrcode() {
      if (this.$shareType == 2) {
        this.submitLoading = true;
        var timestamp = Date.now();
        var lastFourDigits = timestamp.toString().slice(-4);
        let sendData = {
          page: "pages/home/addAdministrators",
          check_path: false,
          width: 150,
          scene:
            this.userAutoIntId +
            "-" +
            lastFourDigits +
            "-" +
            this.CompanyDetail.autoIntId,
        };
        this.GetUnlimitedQRCode(sendData).then((res) => {
          this.imgPath = "data:image/png;base64," + res;
          this.submitLoading = false;
          this.QRVisible = true;
          this.QrCodeLogEdit(lastFourDigits);
        });
      }
    },
    getHalfHourLater() {
      const now = new Date();
      now.setMinutes(now.getMinutes() + 30);
      return now;
    },
    QrCodeLogEdit(time) {
      let sendData = {
        companyId: this.CompanyDetail.id,
        userId: this.userInfo.userId,
        qrCodeUrl: "pages/home/addAdministrators" + time,
        expirationTime: this.getHalfHourLater()
          .toLocaleString()
          .replaceAll("/", "-"),
      };
      this.$api.thirdyParty.QrCodeLogEdit(sendData).then((res) => {
        if (res.code === 0) {
          console.log(res.data);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    changePassword(formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid) return;
        let sendData = {
          id: this.id,
          passWord: this.form.password,
        };
        this.$api.user.CompanyManageUserResetPassword(sendData).then((res) => {
          if (res.code === 0) {
            this.resetDialogVisible = false;
            this.form = {};
            this.$message.success(res.msg);
          } else {
            this.$message.error(res.msg);
          }
        });
      });
    },

    updateUserPassWord(id) {
      this.id = id;
      this.resetDialogVisible = true;
    },
    inputChange(value, field, row) {
      // this.singleEdit(value, field, row);
      // console.log(value, field, row);
    },
    //点击排序触发
    sortChange(column) {
      if (this.sortType == "custom") {
        this.tableData = [
          { atYear: "双击输入框", atMonth: "选项一", cname: "2022-03-01" },
          { atYear: "双击输入", atMonth: "选项一", cname: "2022-03-04" },
          { atYear: "双击输入框", atMonth: "选项一", cname: "2022-03-03" },
          { atYear: "双击输入", atMonth: "选项一", cname: "2022-03-02" },
        ];
      }
    },
    //获取列的隐藏数据
    saveSet(checkList, type) {
      if (checkList) {
        this.tableConfig = JSON.parse(JSON.stringify(checkList));
      }
      this.sortType = type;
      this.tableConfig.forEach((element) => {
        if (element.sortable) {
          element.sortable = type;
        }
      });
    },
    selectChange(value, field) {
      //获取下拉的值
      console.log(value, field);
    },
    getHeight(height) {
      this.tableHeight = height;
    },
    indexMethod(index) {
      console.log(1);
      return (
        (this.$refs.pagination.currentPage - 1) *
          this.$refs.pagination.pageSize +
        index +
        1
      );
    },
    getUserList() {
      this.loading = true;
      const sendData = {
        pageIndex: this.$refs.pagination.currentPage,
        pageSize: this.$refs.pagination.pageSize,
        keyWord: this.searchForm.keyWord,
        deptId: this.searchForm.department,
        roleId: this.searchForm.auth,

        isManage: "",
      };
      this.$api.user.CompanyManageUserPage(sendData).then((res) => {
        this.loading = false;
        if (res.code === 0) {
          this.tableData = res.data.data;
          this.total = res.data.count;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    getRoleList() {
      this.$api.role.getRoles().then((res) => {
        if (res.code === 0) {
          this.roleList = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    getTeamList() {
      this.$api.user.getTeamList().then((res) => {
        if (res.code === 0) {
          this.teamList = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    onSubmit(formName) {
      let First = this.CompanyDetail.autoIntId + 1000 + "_";
      this.$refs[formName].validate((valid) => {
        if (!valid) return;
        this.submitLoading = true;
        var formData = JSON.parse(JSON.stringify(this.form));
        delete formData.account;
        formData.followIndustry =
          formData.followIndustry && formData.followIndustry.join(",");
        formData.account = this.isEdit
          ? this.form.account
          : First.concat(this.form.account);

        console.log(this.form.account);
        this.$api.user.CompanyManageUserEdit(formData).then((res) => {
          if (res.code === 0) {
            this.dialogVisible = false;
            this.$refs[formName].resetFields();
            this.getUserList();
            this.$message.success("保存成功");
          } else {
            this.$message.error(res.msg);
          }
          this.submitLoading = false;
        });
      });
    },
    deleteUser(id) {
      this.$confirm("是否删除？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let formData = new FormData();
          formData.append("id", id);
          this.$api.user.CompanyManageUserDelete(formData).then((res) => {
            if (res.code === 0) {
              this.getUserList();
              this.$message.success("删除成功");
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {});
    },
    editUserInfo(row) {
      console.log(row);
      this.dialogVisible = true;
      this.isEdit = true;
      this.$nextTick(() => {
        // row.followIndustry =
        //   row.followIndustry && row.followIndustry.split(",");
        this.form = row;
        delete this.form.password;
        delete this.form.password2;
      });
    },
    handleCommand(command) {
      switch (command.command) {
        case "delete":
          this.deleteUser(command.row.id);
          break;
        case "edit":
          this.editUserInfo(command.row);
          break;
        case "remind":
          break;
      }
    },
    getRoleName(id) {
      let roleName = "";
      this.roleList.forEach((v) => {
        if (v.id === id) {
          roleName = v.roleName;
        }
      });
      return roleName;
    },
    handleSearch() {
      this.$refs.pagination.currentPage = 1;
      this.$refs.pagination.pageSize = 20;
      this.getUserList();
    },
    resetForm() {
      this.form = {};
      this.$refs.form.clearValidate();
    },
  },
};
</script>

<style lang="less" >
.el-tabs__content {
  position: static !important;
}
// .colleague-dialog .dialog-footer .el-button {
//   background-color: #409eff !important;
// }
.colleague-dialog {
  .el-dialog {
    margin-top: 8vh !important;
  }
  .el-dialog__header {
    padding: 15px 20px;

    .el-dialog__close {
      color: #ddd;
      &:hover {
        color: #fff;
      }
    }
  }
  .el-dialog__body {
    padding-bottom: 0;
    .el-select,
    .el-date-editor {
      width: 100%;
    }
    // .el-radio-group {
    //   .el-radio {
    //     width: calc(50% - 35px);
    //     margin-bottom: 4px;
    //   }
    // }
    .el-input__inner {
      width: 210px !important;
    }
  }
  .account_input {
    .el-input__inner {
      width: 155px !important;
    }
    .el-input-group__prepend {
      padding: 0 10px;
    }
  }
  .el-dialog__footer {
    padding: 0 20px 14px 20px;
  }
}
</style>
